export default {
  "common.brand": "US Fans Spreadsheet",
  "common.tagline": "Niezależne źródło merchu dla fanów",
  "common.buyNow": "Kup teraz",
  "common.visitStore": "Odwiedź sklep",
  "common.guide": "Przewodnik",
  "common.home": "Strona główna",
  "common.shoppingGuide": "Poradnik zakupowy",
  "common.menu": "Menu",
  "common.selectCategory": "Wybierz kategorię…",
  "common.browseCategories": "Przeglądaj kategorie",
  "common.readMore": "Czytaj więcej",
  "common.external": "Otwiera się w nowej karcie",
  "common.backHome": "Wróć do strony głównej",
  "lang.en": "English",
  "lang.es": "Español",
  "lang.fr": "Français",
  "lang.pl": "Polski",
  "footer.tagline": "Niezależne centrum porządkujące merch dla fanów w łatwe do przeglądania kategorie.",
  "footer.resources": "Zasoby",
  "footer.categories": "Kategorie",
  "footer.guide": "Przewodnik po merchu dla fanów",
  "footer.visitStore": "Odwiedź główny sklep",
  "footer.disclaimer": "US Fans Spreadsheet to niezależne źródło informacji i nie jest powiązane ani wspierane przez żadną oficjalną markę lub drużynę.",
  "footer.rights": "Wszelkie prawa zastrzeżone.",
};